import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import theme from '@theme';
import { StyledB2BNavContainer } from './styled';

const B2BHeaderNavContainer = ({ children, isSticky, isMenuItemsOpened }) => {
  const isMenuOpened = isMenuItemsOpened
    ? theme.colors.bg
    : theme.colors.bgSticky;
  const background = isSticky ? isMenuOpened : theme.colors.bg;

  return (
    <ThemeProvider theme={theme}>
      <StyledB2BNavContainer background={background}>
        {children}
      </StyledB2BNavContainer>
    </ThemeProvider>
  );
};

B2BHeaderNavContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isSticky: PropTypes.bool.isRequired,
  isMenuItemsOpened: PropTypes.bool.isRequired,
};

B2BHeaderNavContainer.displayName = 'B2BHeaderNavContainer';

export default B2BHeaderNavContainer;
